module.exports = __webpack_public_path__ + "root-c2082cbd/31a22a81ca67e30ed2acdeff6dfa6d4a.svg";